import { RecentChatMessageSortEnum } from '@/types/generated/graphql';
import { capitalize } from '@shared/utils/capitalize';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { RiArrowDownSLine, RiVerifiedBadgeFill } from 'react-icons/ri';

type Props = {
  onChange: (sortBy: RecentChatMessageSortEnum) => void;
};

export function SortMemberType({ onChange }: Props) {
  const { t } = useTranslation();
  return (
    <Select
      placeholder={t('sort_by').toUpperCase()}
      variant="borderless"
      popupMatchSelectWidth={200}
      size="small"
      suffixIcon={<RiArrowDownSLine />}
      className="bg-surface rounded-4xl placeholder:text-text-950! font-semibold px-2! border border-gray-800 h-7!"
      onChange={onChange}
      classNames={{ popup: { root: 'prevent-click-outside' } }}
      menuItemSelectedIcon={<RiVerifiedBadgeFill />}
      options={[
        { label: capitalize(t('recently_added')), value: RecentChatMessageSortEnum.recentlyAdded },
        { label: capitalize(t('recently_active')), value: RecentChatMessageSortEnum.recentlyActive },
        { label: capitalize(t('name_a_to_z')), value: RecentChatMessageSortEnum.name },
      ]}
    />
  );
}
